import { Component, OnInit, EventEmitter, ElementRef, Output } from '@angular/core';
import { NiceLegalTextModalService } from '../../nice-legal-text/nice-legal-text.service';
import { FormControl, Validators, FormGroup } from '@angular/forms';
import { AuthService } from '@schoolbelle/api/auth';
import { LoadingService } from '@schoolbelle/common/loading';
import { forEach } from 'lodash-es';
import { TranslationService } from '@schoolbelle/common/translation';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-local',
  templateUrl: './local.component.html',
  styleUrls: ['./local.component.css'],
})
export class LocalComponent implements OnInit {
  local:FormControl;
  registration_id:FormControl;
  name:FormControl;
  gender:FormControl;
  personalInfo:FormControl;
  form:FormGroup;
  @Output() onOk = new EventEmitter();
  @Output() onCancel = new EventEmitter();
  constructor(
    protected nice:NiceLegalTextModalService,
    protected auth:AuthService,
    protected loading:LoadingService,
    protected toastr:ToastrService,
    protected translation:TranslationService,
    protected elementRef:ElementRef,
  ) { }

  ngOnInit() {
    this.createForm();
  }
  createForm () {
    this.local = new FormControl(true);
    this.registration_id = new FormControl(null, [Validators.required, Validators.minLength(8), Validators.maxLength(8)]);
    this.name = new FormControl(null, [Validators.required]);
    this.gender = new FormControl('1', [Validators.pattern(/^[01]$/)]);
    this.personalInfo = new FormControl(false, [Validators.requiredTrue]);

    this.form = new FormGroup({
      local:this.local,
      registration_id:this.registration_id,
      name:this.name,
      gender:this.gender,
      personalInfo:this.personalInfo,
    });

  }

  check () {
    const params = this.form.value;
    const subsciption =this.auth.checkParent(params).subscribe(code=>{
      switch (code) {
        case 1:
          this.toastr.success(this.translation.get('checkparent-local-checked'));
          this.onOk.next(true);
          break;
        default :
          this.toastr.error(this.translation.get(`checkparent-local-${code}`) || `errorCode: ${code}`);
          break;  
      }
    }, (e:HttpErrorResponse)=>{
      this.toastr.error(this.translation.get(`checkparent-local-${e.status}-error`) || `errorCode: ${e.status}`);
      console.error(e);
    })
    this.loading.open({message:'', busy:subsciption});
  }
  cancel () {
    this.onCancel.next(null);
  }  

  showNiceLegalTextModal (type:'personal-info'|'third-party-info'|'social-security-info') {
    this.nice.open(type);
  }
  ngAfterViewInit(): void {
    forEach(this.elementRef.nativeElement.querySelectorAll("div[translation-text]"), (el) => this.translation.set(el.id,  el.attributes["translation-text"].value))
  }    


}
